import Vue from "vue";
import "normalize.css/normalize.css";
import Element from "element-ui";
import "./styles/element-variables.scss";
import "@/styles/index.scss";
import App from "./App";
import store from "./store";
import router from "./router";
import { numFormat } from "./utils/index";
import { showLoading, hideLoading } from "@/utils/globalLoading";
import "./icons";
import "@/iconfont/iconfont.js";
import "./permission";
import * as filters from "./filters";
import { copyContent } from "./utils/index";
import handleAutoRefresh from "@/utils/autoFlash";
import { hasPermission } from "@/permission";
import { renderHeader } from "@/utils/table.js";
import searchList from "@/static/searchList";
import { regMap } from "@/static/reg";
import formRules from "./static/formRules";
import inputFilter from "@/directive/inputFilter";
import perms from "@/directive/perms";
import RightToolbar from "@/components/RightToolbar";

// 全局混入
Vue.mixin({
  filters: { numFormat },
  computed: {
    G_renderHeader() {
      return renderHeader;
    },
    routePath() {
      return this.$route.path;
    },
    routePerms() {
      const list = this.$route.path.split("/");
      list.splice(0, 1);
      return list.join(":");
    },
    G_searchList() {
      return searchList;
    },
    G_map() {
      return searchList.map;
    }
  },
  methods: {
    cleanHtmlStyle(v) {
      return v
        .replace(/<style[^>]*>.*?<\/style>/gis, "")
        .replace(/\sstyle=["'][^"']*["']/gi, "")
        .replace(/\sclass=["'][^"']*["']/gi, "");
    },
    hasPerms(key) {
      return hasPermission(this.routePerms + ":" + key);
    },
    routerGo(path, query) {
      router.push({ path, query });
    },
    windowOpen(url) {
      window.open(url);
    },
    filterInput(e, { target, key, reg, type }) {
      const R = regMap.get(type) || reg;
      if (R && e && key) {
        const result = e.replace(R, "");
        target ? this.$set(target, key, result) : (this[key] = result);
      }
    }
  }
});
Vue.prototype.$formRules = formRules;

Vue.use(Element, {
  size: "medium"
});

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.component("RightToolbar", RightToolbar);
Vue.prototype.$showLoading = showLoading;
Vue.prototype.$hideLoading = hideLoading;
Vue.filter("numFormat", numFormat);

Vue.directive("removeAriaHidden", {
  bind(el) {
    const ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach(item => {
      item.removeAttribute("aria-hidden");
    });
  }
});
Vue.directive("inputFilter", inputFilter);
Vue.directive("perms", perms);

Vue.prototype.$copy = copyContent;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});

const env = process.env.NODE_ENV;
env === "production" && handleAutoRefresh();
